import React, { useState } from "react";
import _ from "lodash";
import { useGet, usePost } from "../../common/hooks";
import { Goalie } from "../../common/interfaces";
import { Button, Col, Row } from "antd";
import { MergeCandidateInfo } from "../components/MergeCandidateInfo";

const emptyGoalie = {
  id: -1,
  firstName: "",
  lastName: "",
  email: ""
} as Goalie;

export function MergeGoalies() {
  const [goalie1, setGoalie1] = useState<Goalie>(emptyGoalie);
  const [goalie2, setGoalie2] = useState<Goalie>(emptyGoalie);

  const allGoalies = useGet<Goalie[]>("/api/goalies");
  const mergeGoalies = usePost({ uri: "/api/mergeGoalies", deps: [allGoalies] });

  const sortedGoalies = _.orderBy(allGoalies.data || [], ["lastName", "firstName"]);

  function getGoalie(goalieId: number): Goalie {
    return sortedGoalies.find(g => g.id === goalieId) || emptyGoalie;
  }

  function clearGoalies() {
    setGoalie1(emptyGoalie);
    setGoalie2(emptyGoalie);
  }

  return (
    <div>
      <Row>
        <Col>
          Use this tool to merge goalies. There is no way to undo a merge, so
          make sure you double-check what you're doing!
          <br />
          (NR) means the goalie has never formally registered as a goalie; * means active this season.
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <MergeCandidateInfo
            title={"Goalie to merge (delete)"}
            candidate={goalie1}
            isGoalie={true}
            loading={allGoalies.isLoading}
            candidates={sortedGoalies}
            onChange={(goalieId: number) => setGoalie1(getGoalie(goalieId))}
          />
        </Col>
        <Col span={8}>
          <MergeCandidateInfo
            title={"Goalie to keep"}
            candidate={goalie2}
            isGoalie={true}
            loading={allGoalies.isLoading}
            candidates={sortedGoalies}
            onChange={(goalieId: number) => setGoalie2(getGoalie(goalieId))}
          />
        </Col>
      </Row>
      <Row>
        <Button
          type={"primary"}
          disabled={goalie1.id <= 0 || goalie2.id <= 0 || goalie1.id === goalie2.id}
          loading={mergeGoalies.isLoading}
          onClick={() =>
            mergeGoalies.send(
              { goalie1: goalie1.id, goalie2: goalie2.id },
              clearGoalies
            )
          }
        >
          Merge
        </Button>
      </Row>
    </div>
  );
}
